



























import { Component, Prop } from 'vue-property-decorator';
import { AgencyType } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { FormatMixin } from '@/mixins/FormatMixin';
import { Util } from '@/utils/Util';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class AgencyTypeSelect extends mixins(BaseMixin, FormatMixin) {
  @Prop()
  type!: AgencyType;

  updateType(type: AgencyType) {
    this.$emit('update-type', type);
  }

  get options() {
    return [AgencyType.ALLIANZ, AgencyType.GENERIC, AgencyType.HDI];
  }
  label(type: AgencyType) {
    return Util.formatAgencyType(type);
  }

  isSelected(type: AgencyType) {
    return type === this.type;
  }
}
